module.exports = __webpack_public_path__ + "img/vid_2_splash.c2e23607.jpg";